import { EmailUnsubscribeState } from "@/services/apiTypes";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/** Query param carrying the signed token from the email's unsubscribe link. */
export const EMAIL_PREFERENCES_TOKEN_PARAM = "email_prefs_token";

export const preferencesApi = createApi({
  reducerPath: "preferencesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_LIGHT_BASE_API}/preferences/v1`,
    prepareHeaders: (headers) => {
      const token = new URL(window.location.href).searchParams.get(
        EMAIL_PREFERENCES_TOKEN_PARAM,
      );
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    unsubscribeEmail: builder.mutation<EmailUnsubscribeState, void>({
      query: () => ({ url: "/email/unsubscribe", method: "POST" }),
    }),
    resubscribeEmail: builder.mutation<EmailUnsubscribeState, void>({
      query: () => ({ url: "/email/resubscribe", method: "POST" }),
    }),
    unsubscribeAllEmail: builder.mutation<EmailUnsubscribeState, void>({
      query: () => ({ url: "/email/unsubscribe-all", method: "POST" }),
    }),
    resubscribeAllEmail: builder.mutation<EmailUnsubscribeState, void>({
      query: () => ({ url: "/email/resubscribe-all", method: "POST" }),
    }),
  }),
});

export const {
  useUnsubscribeEmailMutation,
  useResubscribeEmailMutation,
  useUnsubscribeAllEmailMutation,
  useResubscribeAllEmailMutation,
} = preferencesApi;
